var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJewelry(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1511_9312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.8194 96.2617C103.852 85.9119 105.163 74.5845 101.448 62.6776C101.266 62.0765 100.571 61.1784 100.137 61.2291C97.4278 61.316 94.7335 61.6274 91.9451 61.8737C99.6078 78.8939 92.5245 95.2477 80.3569 102.918C68.2979 110.501 52.2774 108.777 41.7828 98.6807C36.6882 93.7756 33.3997 87.2934 32.4505 80.2853C31.5014 73.2771 32.9471 66.1538 36.5535 60.0703C40.0573 53.9586 45.5814 49.259 52.1757 46.78C61.4101 43.2239 70.4418 44.0785 79.5676 48.7863C79.3503 45.4184 79.1621 42.4345 78.9448 39.0449C64.3292 32.2803 44.1075 37.9223 34.0041 51.9151C21.1122 69.7609 25.3128 93.9223 43.4846 106.684C60.5482 118.62 84.7894 113.992 96.8194 96.2617Z",
    fill: "#FF921E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2475 59.8892L100.607 49.076L91.7422 40.2109L80.9434 59.556L81.2475 59.8892Z",
    fill: "#FF921E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.61 58.0206L101.599 50.0103L82.689 61.0046L82.841 61.4391L109.61 58.0206Z",
    fill: "#FF921E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4315 38.7407C88.0487 36.242 85.5935 33.8302 82.8123 31.0491C81.7186 40.5079 80.7048 49.3657 79.6836 58.2162L80.1469 58.332C83.5268 52.2869 86.9067 46.2344 90.2865 40.1748C90.4893 39.7692 90.6488 38.9725 90.4315 38.7407Z",
    fill: "#FF921E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.519 35.6555L95.2623 27.3989C94.386 31.0202 93.582 34.3301 92.7129 37.9297L103.519 35.6555Z",
    fill: "#FF921E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.708 47.2799C102.57 43.7237 103.36 40.4646 104.222 36.8867L93.814 39.4071L101.708 47.2799Z",
    fill: "#FF921E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.507 45.52L105.482 37.5024L102.911 48.0984L113.507 45.52Z",
    fill: "#FF921E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.0384 26.6963L84.0073 29.4992L91.5541 37.046L94.0384 26.6963Z",
    fill: "#FF921E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.29 56.9633C112.014 53.4289 112.601 50.3435 113.253 47.0481L103.664 49.3295L111.29 56.9633Z",
    fill: "#FF921E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9999 6.51836C86.8304 6.53753 102.966 13.2319 114.867 25.1329C126.768 37.0338 133.462 53.1695 133.481 70C133.462 86.8305 126.768 102.966 114.867 114.867C102.966 126.768 86.8304 133.462 69.9999 133.482C53.1694 133.462 37.0337 126.768 25.1328 114.867C13.2318 102.966 6.53753 86.8305 6.51836 70C6.53753 53.1695 13.2318 37.0338 25.1328 25.1329C37.0337 13.2319 53.1694 6.53753 69.9999 6.51836ZM69.9999 0C51.4348 0 33.6301 7.37496 20.5025 20.5025C7.37496 33.6301 0 51.4348 0 70C0 88.5651 7.37496 106.37 20.5025 119.497C33.6301 132.625 51.4348 140 69.9999 140C88.5651 140 106.37 132.625 119.497 119.497C132.625 106.37 140 88.5651 140 70C140 51.4348 132.625 33.6301 119.497 20.5025C106.37 7.37496 88.5651 0 69.9999 0Z",
    fill: "#007FC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3218 22.3218L117.678 117.678",
    stroke: "#007FC6",
    strokeWidth: 9,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1511_9312"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 140,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJewelry);
export default __webpack_public_path__ + "static/media/jewelry.0e21103514612fe4bedbb859be802d56.svg";
export { ForwardRef as ReactComponent };